/**
 * diagnostics/index.js
 * Diagnostics module entry point for DataTableWrapper.
 */
import { DiagnosticRegistry, defaultDiagnosticRegistry } from './DiagnosticRegistry';
import { DiagnosticEngine } from './DiagnosticEngine';
import { headerIconOverlapPlugin } from './plugins/headerIconOverlap';
import { checkboxVisibilityPlugin } from './plugins/checkboxVisibility';

// Auto-register built-in plugins
defaultDiagnosticRegistry.register(headerIconOverlapPlugin);
defaultDiagnosticRegistry.register(checkboxVisibilityPlugin);

const defaultEngine = new DiagnosticEngine(defaultDiagnosticRegistry);

/**
 * Runs diagnostics on registered plugins or a specific target.
 * @param {Object|string|HTMLElement} [optionsOrTarget]
 * @returns {Promise<import('./DiagnosticEngine').DiagnosticReport>}
 */
export function diagnose(optionsOrTarget) {
    return defaultEngine.diagnose(optionsOrTarget);
}

/**
 * Registers a diagnostic plugin with the default registry.
 * @param {import('./DiagnosticRegistry').DiagnosticPlugin} plugin
 */
export function registerDiagnostic(plugin) {
    defaultDiagnosticRegistry.register(plugin);
}

/**
 * Unregisters a diagnostic plugin by ID.
 * @param {string} id
 */
export function unregisterDiagnostic(id) {
    return defaultDiagnosticRegistry.unregister(id);
}

/**
 * Returns all registered diagnostic plugins.
 * @returns {import('./DiagnosticRegistry').DiagnosticPlugin[]}
 */
export function getDiagnostics() {
    return defaultDiagnosticRegistry.getAll();
}

export {
    DiagnosticRegistry,
    defaultDiagnosticRegistry,
    DiagnosticEngine,
    defaultEngine,
    headerIconOverlapPlugin,
    checkboxVisibilityPlugin
};
